import React, { useState, useEffect } from 'react';
import { FormControl, FormControlLabel, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import MuiCheckbox from '@mui/material/Checkbox';

const useStyles = makeStyles(() => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  label: {
    marginLeft: 0,
    '& .MuiTypography-body1': {
    },
  },
  rowCheckbox: {
    padding: 3,
  },
  tooltipPopper: {
    '&[data-popper-placement*="bottom"] .MuiTooltip-arrow': {
      left: '-50% !important',
      transform: 'translateX(-50%)',
    },
  },
}));

export default function Checkbox(props) {
  const classes = useStyles();
  const {
    id, name, label, onChange, className, values, ...others
  } = props;

  const [isChecked, setisChecked] = useState(false);
  const labelId = id ? `${id}-label` : undefined;

  const handleChange = (e) => {
    setisChecked(!isChecked);
    onChange && onChange(e);
  };

  useEffect(() => {
    // console.log(values);
  }, [values]);

  return (
   <FormControl>
    <Tooltip
      title={
        others.showDisabledTooltip && others.disabled
          ? props.tooltip || ''
          : ''
      }
      arrow
      classes={{ popper: classes.tooltipPopper }}
      placement="bottom-start"
    >
        <FormControlLabel
          control={
            <MuiCheckbox
              id={id}
              name={name}
              color="primary"
              onChange={e => handleChange(e)}
              icon={<CheckBoxOutlineBlankIcon style={{ fontSize: 25 }} />}
              checkedIcon={<CheckBoxIcon style={{ fontSize: 25 }} />}
              inputProps={{ 'aria-label': 'uncontrolled-checkbox' }}
              className={classes[className]}
              checked={isChecked}
              style={{
                opacity:
                  others.showDisabledTooltip && others.disabled ? 0.5 : 1,
              }}
              {...((({ showDisabledTooltip, tooltip, ...rest }) => rest)(others))}
            />
          }
          id={labelId}
          label={label}
          className={classes?.label}
        />
    </Tooltip>
  </FormControl>
  );
}
